import api from "../../../api";

export function productMapping(){
    return api.get("product_mapping");
}

export function deleteProduct(id){
    return api.delete(`product_mapping/${id}`);
}

export function addNewProduct(payload){
    return api.post(`product_mapping`, payload);
}

export function addCombo(payload){
    return api.post("combo_product_mapping", payload);
}